import { render, staticRenderFns } from "./QuickUser.vue?vue&type=template&id=95c015e0&scoped=true"
import script from "./QuickUser.vue?vue&type=script&lang=js"
export * from "./QuickUser.vue?vue&type=script&lang=js"
import style0 from "./QuickUser.vue?vue&type=style&index=0&id=95c015e0&prod&lang=scss&scoped=true"
import style1 from "./QuickUser.vue?vue&type=style&index=1&id=95c015e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c015e0",
  null
  
)

export default component.exports